import { requestHandler } from '../api'

export const getReklaimProtectEmailAddresses = async (userAlias) => {
  let emailAddresses
  try {
    emailAddresses = await requestHandler(`/protect/profile-info/email-addresses/${userAlias}`, 'GET')
  } catch (error) {
    emailAddresses = null
  }
  return emailAddresses?.emailAddresses
}

export const setReklaimProtectEmailAddress = async (userAlias, data) =>
  requestHandler(`/protect/profile-info/email-addresses/${userAlias}`, 'POST', data)

export const updateReklaimProtectEmailAddress = async (userAlias, data) =>
  requestHandler(`/protect/profile-info/email-addresses/${userAlias}`, 'PATCH', data)

export const deleteReklaimProtectEmailAddress = async (userAlias, data) =>
  requestHandler(`/protect/profile-info/email-addresses/${userAlias}`, 'DELETE', data)
